import { render, staticRenderFns } from "./GlucoseAction.vue?vue&type=template&id=38b05e05&scoped=true&"
import script from "./GlucoseAction.vue?vue&type=script&lang=js&"
export * from "./GlucoseAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b05e05",
  null
  
)

export default component.exports